import { render } from "./AppUploadInfo.vue?vue&type=template&id=807bc976&scoped=true&ts=true"
import script from "./AppUploadInfo.vue?vue&type=script&lang=ts"
export * from "./AppUploadInfo.vue?vue&type=script&lang=ts"

import "./AppUploadInfo.vue?vue&type=style&index=0&id=807bc976&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-807bc976"]])

export default __exports__